import React, { useEffect, useRef } from "react";

const InfogramEmbed = ({ id, type = "interactive", title }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Ensure script is only added once globally
    if (!document.getElementById("infogram-async")) {
      const script = document.createElement("script");
      script.id = "infogram-async";
      script.src = "https://e.infogram.com/js/dist/embed-loader-min.js";
      script.async = true;
      document.body.appendChild(script);
    } else if (window.InfogramEmbeds?.process) {
      // If script already loaded, reprocess embeds
      window.InfogramEmbeds.process();
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="infogram-embed"
      data-id={id}
      data-type={type}
      data-title={title}
    ></div>
  );
};

export default InfogramEmbed;
